module.exports = __webpack_public_path__ + "img/dark-mud-decal-27.49bde0d9.png";